var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g4, _g5, _g6, _g7, _g8, _g9, _path26, _g10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitepaperValidation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 253,
    viewBox: "0 0 185 253",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3712 33.325C48.8402 32.6913 46.8638 30.7147 46.2299 28.1837L46.1213 27.7524L46.013 28.1837C45.379 30.7147 43.4024 32.6915 40.8715 33.325L40.4397 33.4341L40.8715 33.5421C43.4024 34.1759 45.3793 36.1525 46.013 38.6834L46.1213 39.1157L46.2299 38.6834C46.8641 36.1525 48.8402 34.1759 51.3712 33.5421L51.8037 33.4341L51.3712 33.325Z",
    fill: "#46A9D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4258 54.6358C85.4063 54.1297 83.8299 52.5528 83.3233 50.5335L83.2373 50.189L83.1503 50.5335C82.6445 52.5528 81.0673 54.1297 79.0478 54.6358L78.7035 54.723L79.0478 54.81C81.0673 55.3148 82.6445 56.8922 83.1503 58.9108L83.2373 59.2558L83.3233 58.9108C83.8299 56.8922 85.4063 55.3148 87.4258 54.81L87.7706 54.723L87.4258 54.6358Z",
    fill: "#46A9D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.614 34.9267C125.933 34.5057 124.621 33.1946 124.2 31.5143L124.129 31.2275L124.056 31.5143C123.635 33.1944 122.323 34.5057 120.643 34.9267L120.356 34.9992L120.643 35.072C122.323 35.4923 123.635 36.8045 124.056 38.4851L124.129 38.7718L124.2 38.4851C124.621 36.8048 125.933 35.4923 127.614 35.072L127.9 34.9992L127.614 34.9267Z",
    fill: "#46A9D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.46 41.7659C133.346 41.2364 131.695 39.5861 131.165 37.472L131.075 37.1113L130.984 37.472C130.454 39.5864 128.803 41.2364 126.688 41.7659L126.328 41.8571L126.688 41.9487C128.803 42.4776 130.454 44.1288 130.984 46.2433L131.075 46.6041L131.165 46.2433C131.695 44.1288 133.346 42.4776 135.46 41.9487L135.821 41.8571L135.46 41.7659Z",
    fill: "#46A9D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2844 0H58.9493C57.0621 0 55.5315 1.52989 55.5315 3.41706V33.5472C55.5315 35.4346 57.0621 36.9645 58.9493 36.9645H81.6871C83.574 36.9645 85.1039 35.4346 85.1039 33.5472V10.8192L74.2844 0Z",
    fill: "url(#paint0_linear_391_8)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2844 0V7.40216C74.2844 9.28959 75.8146 10.8192 77.7012 10.8192H85.1039L74.2844 0Z",
    fill: "#E9F5FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.681 5.41211H60.1707C59.4941 5.41211 58.9454 5.96054 58.9454 6.63739C58.9454 7.31423 59.4941 7.86267 60.1707 7.86267H68.681C69.3576 7.86267 69.9062 7.31423 69.9062 6.63739C69.9062 5.96054 69.3576 5.41211 68.681 5.41211Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9544 10.519H60.1707C59.4941 10.519 58.9454 11.0675 58.9454 11.7443C58.9454 12.4212 59.4941 12.9696 60.1707 12.9696H71.9544C72.631 12.9696 73.1797 12.4212 73.1797 11.7443C73.1797 11.0675 72.6313 10.519 71.9544 10.519Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3201 15.626H60.1707C59.4941 15.626 58.9454 16.1744 58.9454 16.8513C58.9454 17.5281 59.4941 18.0765 60.1707 18.0765H79.3201C79.9967 18.0765 80.5454 17.5281 80.5454 16.8513C80.5454 16.1747 79.9967 15.626 79.3201 15.626Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3201 20.7319H60.1707C59.4941 20.7319 58.9454 21.2804 58.9454 21.9572C58.9454 22.6341 59.4941 23.1825 60.1707 23.1825H79.3201C79.9967 23.1825 80.5454 22.6341 80.5454 21.9572C80.5454 21.2806 79.9967 20.7319 79.3201 20.7319Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3201 25.8389H60.1707C59.4941 25.8389 58.9454 26.3873 58.9454 27.0641C58.9454 27.741 59.4941 28.2894 60.1707 28.2894H79.3201C79.9967 28.2894 80.5454 27.741 80.5454 27.0641C80.5454 26.3873 79.9967 25.8389 79.3201 25.8389Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3201 30.9453H60.1707C59.4941 30.9453 58.9454 31.4937 58.9454 32.1706C58.9454 32.8474 59.4941 33.3959 60.1707 33.3959H79.3201C79.9967 33.3959 80.5454 32.8474 80.5454 32.1706C80.5454 31.4937 79.9967 30.9453 79.3201 30.9453Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.684 36.2397H96.3485C94.4614 36.2397 92.9307 37.7696 92.9307 39.6568V69.7869C92.9307 71.6744 94.4614 73.2042 96.3485 73.2042H119.086C120.973 73.2042 122.503 71.6744 122.503 69.7869V47.0592L111.684 36.2397Z",
    fill: "url(#paint1_linear_391_8)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.684 36.2397V43.6419C111.684 45.5291 113.214 47.0592 115.1 47.0592H122.503L111.684 36.2397Z",
    fill: "#E9F5FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.08 41.6519H97.5699C96.8933 41.6519 96.3446 42.2003 96.3446 42.8771C96.3446 43.554 96.8933 44.1024 97.5699 44.1024H106.08C106.757 44.1024 107.305 43.554 107.305 42.8771C107.305 42.2005 106.757 41.6519 106.08 41.6519Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.354 46.7583H97.5699C96.8933 46.7583 96.3446 47.3067 96.3446 47.9836C96.3446 48.6604 96.8933 49.2089 97.5699 49.2089H109.354C110.03 49.2089 110.579 48.6604 110.579 47.9836C110.579 47.307 110.03 46.7583 109.354 46.7583Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.719 51.8657H97.5696C96.893 51.8657 96.3444 52.4142 96.3444 53.0908C96.3444 53.7679 96.893 54.316 97.5696 54.316H116.719C117.396 54.316 117.944 53.7679 117.944 53.0908C117.944 52.4142 117.396 51.8657 116.719 51.8657Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.719 56.9717H97.5696C96.893 56.9717 96.3444 57.5201 96.3444 58.197C96.3444 58.8738 96.893 59.4222 97.5696 59.4222H116.719C117.396 59.4222 117.944 58.8738 117.944 58.197C117.944 57.5201 117.396 56.9717 116.719 56.9717Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.719 62.0791H97.5696C96.893 62.0791 96.3444 62.6273 96.3444 63.3044C96.3444 63.981 96.893 64.5297 97.5696 64.5297H116.719C117.396 64.5297 117.944 63.981 117.944 63.3044C117.944 62.6273 117.396 62.0791 116.719 62.0791Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.719 67.1855H97.5696C96.893 67.1855 96.3444 67.734 96.3444 68.4108C96.3444 69.0877 96.893 69.6361 97.5696 69.6361H116.719C117.396 69.6361 117.944 69.0877 117.944 68.4108C117.944 67.734 117.396 67.1855 116.719 67.1855Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.61 21.1874C123.005 20.883 122.268 21.1261 121.964 21.7304L119.662 26.2985C117.893 19.7423 114.088 13.8198 108.804 9.45999C102.926 4.60861 95.4832 1.93701 87.8478 1.93701C87.1712 1.93701 86.6225 2.48545 86.6225 3.16229C86.6225 3.83914 87.1712 4.38757 87.8478 4.38757C101.722 4.38757 113.873 13.8617 117.35 27.1383L112.454 24.7515C111.845 24.4552 111.112 24.7079 110.815 25.3163C110.519 25.9243 110.771 26.658 111.38 26.9548L118.879 30.611C119.052 30.6953 119.235 30.735 119.416 30.735C119.864 30.735 120.296 30.488 120.511 30.0609L124.152 22.8337C124.457 22.2289 124.214 21.492 123.61 21.1874Z",
    fill: "url(#paint2_linear_391_8)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7508 66.7576C74.8769 66.7576 62.7251 57.2835 59.249 44.0068L64.145 46.3937C64.7537 46.69 65.4869 46.4373 65.7834 45.8288C66.0799 45.2211 65.8273 44.4872 65.219 44.1904L57.7191 40.5342C57.5461 40.4499 57.3633 40.4102 57.1829 40.4102C56.7345 40.4102 56.3029 40.6572 56.0878 41.0843L52.4465 48.3115C52.1419 48.9158 52.385 49.6529 52.9893 49.9573C53.5933 50.2617 54.3305 50.0186 54.6348 49.4142L56.9366 44.8462C58.7062 51.4026 62.5112 57.3249 67.7943 61.6847C73.673 66.5361 81.1156 69.2077 88.751 69.2077C89.4279 69.2077 89.9763 68.6592 89.9763 67.9824C89.9761 67.306 89.4276 66.7576 88.7508 66.7576Z",
    fill: "#46A9D5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.205 238.799L163.293 213.92C177.358 205.8 177.358 185.496 163.293 177.375L120.205 152.497C102.865 142.486 81.504 142.486 64.164 152.497L21.0765 177.375C7.01182 185.496 7.01182 205.8 21.0765 213.92L64.164 238.799C81.504 248.809 102.865 248.809 120.205 238.799Z",
    fill: "url(#paint3_radial_391_8)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.235 232.635L153.489 211.704C166.184 204.375 166.184 186.055 153.489 178.726L117.235 157.795C101.547 148.735 82.2187 148.735 66.5307 157.795L30.2766 178.726C17.5811 186.055 17.5811 204.375 30.2766 211.704L66.5307 232.635C82.2187 241.695 101.547 241.695 117.235 232.635Z",
    fill: "url(#paint4_radial_391_8)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.868 227.341L144.293 210.354C155.615 203.82 155.615 187.476 144.293 180.942L114.868 163.954C100.832 155.85 83.5373 155.85 69.4972 163.954L40.0726 180.942C28.7503 187.476 28.7503 203.82 40.0726 210.354L69.4972 227.341C83.5332 235.446 100.828 235.446 114.868 227.341Z",
    fill: "url(#paint5_radial_391_8)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.204 221.615L134.795 208.571C144.744 202.828 144.744 188.468 134.795 182.725L112.204 169.681C99.8155 162.528 84.558 162.528 72.17 169.681L49.5788 182.725C39.6298 188.468 39.6298 202.828 49.5788 208.571L72.17 221.615C84.558 228.768 99.8155 228.768 112.204 221.615Z",
    fill: "url(#paint6_radial_391_8)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.535 215.888L125.293 206.792C133.868 201.84 133.868 189.464 125.293 184.512L109.535 175.416C98.7989 169.218 85.5747 169.218 74.8387 175.416L59.081 184.512C50.5053 189.464 50.5053 201.84 59.081 206.792L74.8387 215.888C85.5747 222.087 98.7989 222.087 109.535 215.888Z",
    fill: "url(#paint7_radial_391_8)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.866 210.158L115.79 205.005C122.993 200.844 122.993 190.448 115.79 186.292L106.866 181.139C97.7823 175.896 86.5872 175.896 77.5032 181.139L68.579 186.292C61.3766 190.452 61.3766 200.848 68.579 205.005L77.5032 210.158C86.5872 215.401 97.7823 215.401 106.866 210.158Z",
    fill: "url(#paint8_radial_391_8)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 137.535L142.653 108.397L92.1868 79.2593L41.7205 108.397L92.1868 137.535Z",
    fill: "url(#paint9_linear_391_8)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 195.806L142.653 166.668V108.397L92.1868 137.535V195.806Z",
    fill: "url(#paint10_linear_391_8)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 195.806L41.7205 166.668V108.397L92.1868 137.535V195.806Z",
    fill: "url(#paint11_linear_391_8)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_df_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3762 131.697L50.0461 115.341C49.1606 114.828 48.8573 113.701 49.3697 112.816C49.8821 111.93 51.0094 111.627 51.8949 112.139L80.225 128.495C81.1105 129.008 81.4138 130.135 80.9014 131.021C80.389 131.906 79.2617 132.209 78.3762 131.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_df_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.338 152.406V185.123C90.338 186.144 91.166 186.972 92.1868 186.972C93.2075 186.972 94.0355 186.144 94.0355 185.123V152.406C94.0355 151.386 93.2075 150.558 92.1868 150.558C91.166 150.558 90.338 151.386 90.338 152.406Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_df_391_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.993 131.697L134.323 115.341C135.209 114.828 135.512 113.701 135 112.816C134.487 111.93 133.36 111.627 132.475 112.139L104.144 128.495C103.259 129.008 102.956 130.135 103.468 131.021C103.98 131.906 105.108 132.209 105.993 131.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7078 121.203L117.16 108.241C118.275 107.597 118.275 105.986 117.16 105.343L96.6632 93.5081C93.8962 91.9094 90.4814 91.9094 87.7144 93.5081L67.7017 105.064C66.3695 105.831 66.3695 107.753 67.7017 108.52L89.6698 121.203C91.2316 122.105 93.1542 122.105 94.7119 121.203H94.7078Z",
    fill: "#143247"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M51.2759 22.2419L63.3237 101.424C63.4057 101.887 63.5328 102.588 63.6681 103.035C64.4879 105.744 66.2219 108.126 68.706 109.585L88.0629 120.953C88.0998 120.973 88.6327 121.285 88.6696 121.301C90.5184 122.199 92.773 122.191 94.6177 121.277L116.209 108.593C117.938 107.609 119.025 106.08 119.472 104.232C119.488 104.162 119.718 102.752 119.718 102.658L130.675 22.2378C130.675 21.5573 117.237 21.0039 116.557 21.0039H65.4103C64.7298 21.0039 51.2759 21.5573 51.2759 22.2378V22.2419Z",
    fill: "url(#paint12_linear_391_8)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M53.8503 23.476L63.4877 101.375C63.5533 101.748 63.664 102.6 63.7623 102.961C64.5002 105.638 66.0825 108.044 68.5257 109.479L88.0588 120.953C88.1285 120.994 88.5999 121.269 88.6778 121.301C90.5552 122.191 92.8139 122.174 94.6832 121.248L115.975 108.737C117.758 107.749 118.914 106.396 119.369 104.589C119.406 104.445 119.607 103.223 119.607 103.031L128.371 23.4678C128.371 22.1027 116.959 21 115.594 21H66.6441C65.279 21 53.8544 22.1068 53.8544 23.4678L53.8503 23.476Z",
    fill: "url(#paint13_linear_391_8)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.4205 24.7097L63.6475 101.325C63.6967 101.604 63.7869 102.617 63.8566 102.887C64.5125 105.531 65.9431 107.962 68.3412 109.372L88.0465 120.953C88.1531 121.014 88.5589 121.252 88.6737 121.301C90.5799 122.187 92.8426 122.162 94.7324 121.223L115.721 108.884C117.561 107.896 118.779 106.716 119.246 104.953C119.304 104.74 119.472 103.703 119.472 103.412L126.047 24.7097C126.047 22.6641 116.659 21.0039 114.614 21.0039H67.8657C65.8202 21.0039 56.4205 22.6641 56.4205 24.7097Z",
    fill: "url(#paint14_linear_391_8)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M58.9949 25.9435L63.8156 101.276C63.8484 101.461 63.914 102.633 63.955 102.813C64.5289 105.433 65.812 107.884 68.1609 109.266L88.0383 120.953C88.1818 121.035 88.5261 121.236 88.6778 121.301C90.6126 122.178 92.8836 122.146 94.7939 121.195L115.479 109.028C117.373 108.036 118.66 107.031 119.135 105.31C119.213 105.027 119.353 104.17 119.353 103.785L123.735 25.9435C123.735 23.2175 116.368 21.0039 113.642 21.0039H69.0955C66.3695 21.0039 58.9949 23.2134 58.9949 25.9435Z",
    fill: "url(#paint15_linear_391_8)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M61.5651 27.1818L63.9755 101.231C63.9919 101.326 64.0288 102.654 64.0452 102.744C64.5412 105.347 65.6685 107.807 67.9723 109.163L88.026 120.957C88.2022 121.064 88.4851 121.219 88.6737 121.306C90.6373 122.179 92.9123 122.134 94.8472 121.174L115.233 109.18C117.18 108.188 118.533 107.356 119.021 105.675C119.123 105.322 119.226 104.65 119.226 104.166L121.419 27.1818C121.419 23.7712 116.077 21.0083 112.667 21.0083H70.3171C66.9065 21.0083 61.5651 23.7712 61.5651 27.1818Z",
    fill: "url(#paint16_linear_391_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 28.4157V102.666C63.8484 105.29 65.2381 107.72 67.5009 109.053L87.7268 120.953C87.9399 121.08 88.1572 121.199 88.3868 121.297C90.379 122.162 92.6582 122.113 94.6177 121.142L114.7 109.319C117.221 108.069 118.816 107.356 118.816 104.539V28.4157C118.816 24.3246 115.499 21.0083 111.408 21.0083H71.26C67.1689 21.0083 63.8525 24.3246 63.8525 28.4157H63.8484Z",
    fill: "url(#paint17_linear_391_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_391_8",
    x: 55.5315,
    y: 0,
    width: 29.5724,
    height: 41.3873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.42293
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52867
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_391_8",
    x: 92.9307,
    y: 36.2397,
    width: 29.5724,
    height: 41.3873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.42293
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52867
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_391_8",
    x: 86.6225,
    y: 1.93701,
    width: 37.6611,
    height: 33.2208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.42293
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52867
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_391_8",
    x: 41.7205,
    y: 79.2593,
    width: 100.933,
    height: 62.2754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_391_8",
    x: 92.1868,
    y: 108.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_391_8",
    x: 41.7205,
    y: 108.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_df_391_8",
    x: 44.1205,
    y: 106.89,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_8",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_391_8",
    x: 85.338,
    y: 145.558,
    width: 13.6976,
    height: 49.4141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_8",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_df_391_8",
    x: 98.2189,
    y: 106.89,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_8",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_8",
    x1: 85.9662,
    y1: 26.0327,
    x2: 63.6584,
    y2: 5.36748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_8",
    x1: 123.365,
    y1: 62.2725,
    x2: 101.058,
    y2: 41.6072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_391_8",
    x1: 125.382,
    y1: 22.2184,
    x2: 109.352,
    y2: -2.05626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.5007 197.401) rotate(-166.533) scale(81.3394 39.8701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.2554 196.745) rotate(-166.508) scale(70.859 34.7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.6123 196.955) rotate(-166.473) scale(60.3816 29.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6727 196.732) rotate(-166.421) scale(49.8987 24.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.7292 196.514) rotate(-166.345) scale(39.4152 19.5695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_391_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7837 196.286) rotate(-166.213) scale(28.9341 14.4944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_391_8",
    x1: 145.596,
    y1: 120.301,
    x2: 117.426,
    y2: 63.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_391_8",
    x1: 144.125,
    y1: 169.956,
    x2: 95.2366,
    y2: 137.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_391_8",
    x1: 93.6584,
    y1: 169.956,
    x2: 44.7704,
    y2: 137.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_391_8",
    x1: 90.9754,
    y1: 21.0039,
    x2: 90.9754,
    y2: 121.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_391_8",
    x1: 91.1107,
    y1: 21,
    x2: 91.1107,
    y2: 121.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_391_8",
    x1: 91.2337,
    y1: 21.0039,
    x2: 91.2337,
    y2: 121.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_391_8",
    x1: 91.3649,
    y1: 21.0039,
    x2: 91.3649,
    y2: 121.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_391_8",
    x1: 91.4919,
    y1: 21.0083,
    x2: 91.4919,
    y2: 121.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_391_8",
    x1: 91.3321,
    y1: 21.0083,
    x2: 91.3321,
    y2: 121.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaperValidation);
export default __webpack_public_path__ + "static/media/whitepaper-validation.7151d4cfe735d00e351d5f2c6738011f.svg";
export { ForwardRef as ReactComponent };